import { DestroyRef, Directive, forwardRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { MatAutocomplete } from '@angular/material/autocomplete';

@Directive({
  selector: 'input[fdmEmailSelection]',
  standalone: true,
  providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => EmailSelectionDirective), multi: true }]
})
export class EmailSelectionDirective implements Validator, OnInit {
  @Input({ required: true }) fdmEmailSelection!: MatAutocomplete;

  private readonly destroyRef = inject(DestroyRef);
  private selectedEmail = '';
  private onValidatorChange = () => {};

  ngOnInit(): void {
    this.fdmEmailSelection.optionSelected.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => {
      this.selectedEmail = this.normalize(event.option.value);
      this.onValidatorChange();
    });
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const email = this.normalize(control.value);
    if (control.pristine) {
      this.selectedEmail = email;
    }

    return !email || email === this.selectedEmail ? null : { emailSelectionRequired: true };
  }

  registerOnValidatorChange(callback: () => void): void {
    this.onValidatorChange = callback;
  }

  private normalize(value: string | null | undefined): string {
    return (value ?? '').trim().toLowerCase();
  }
}